import { Box, Typography } from '@mui/material';
import { useState } from 'react';

import { handleApiError } from '../utils/api.utils';
import { CenteredModal, ModalTitle } from './CenteredModal';
import { LowerCaseButton } from './common';

interface IConfirmationModalProps {
  header: string;
  confirmLabel: string;
  open: boolean;
  onClose: () => void;
  handleConfirm: () => void | Promise<void>;
}

const ConfirmationModal = ({
  header,
  confirmLabel,
  open,
  onClose,
  handleConfirm,
}: IConfirmationModalProps) => {
  const [isConfirming, setIsConfirming] = useState(false);

  // On garde la modale ouverte tant que l'action n'a pas abouti, pour ne pas
  // laisser croire qu'un échec a été pris en compte.
  const onConfirm = async () => {
    setIsConfirming(true);
    try {
      await handleConfirm();
      onClose();
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsConfirming(false);
    }
  };

  return (
    <CenteredModal open={open} handleClose={onClose}>
      <ModalTitle>
        <Typography variant="h5">{header}</Typography>
      </ModalTitle>
      <Box
        component="div"
        sx={{ display: 'flex', flexDirection: 'column', gap: '16px', padding: '30px' }}
      >
        <LowerCaseButton
          variant="outlined"
          type="submit"
          disabled={isConfirming}
          onClick={onConfirm}
        >
          {confirmLabel}
        </LowerCaseButton>
        <LowerCaseButton variant="contained" disabled={isConfirming} onClick={onClose}>
          Annuler
        </LowerCaseButton>
      </Box>
    </CenteredModal>
  );
};

export default ConfirmationModal;
